import { Sheet, Table, Chip } from "@mui/joy";
import { SEdit, SDelete } from "../../../../styles/StyledMUI";
import { hrSheetSx, hrTableSx, hrAccentColor, textTokens } from "../../../../styles/globalStyles";
import DarkTypography from "../../../common/DarkTypography";
import DarkCard from "../../../common/DarkCard";
import IconButtonCTA from "../../../common/IconButtonCTA";
import type { Prestation } from "../../../../api/billing/Billing.typed";
import { formatPrice, htToTtc } from "../../shared/billingUtils";

type Props = {
  groupName: string;
  items: Prestation[];
  qualifMap: Map<number, string>;
  canEdit: boolean;
  onEdit: (p: Prestation) => void;
  onDelete: (p: Prestation) => void;
};

export default function PrestationGroupCard({
  groupName,
  items,
  qualifMap,
  canEdit,
  onEdit,
  onDelete,
}: Props) {
  return (
    <DarkCard dense>
      <DarkTypography level="title-md" sx={{ mb: 0.5, color: hrAccentColor }}>
        {groupName || "Sans catégorie"}
        <DarkTypography
          component="span"
          level="body-sm"
          sx={{ color: textTokens.color.faint, ml: 1 }}
        >
          ({items.length} prestation{items.length > 1 ? "s" : ""})
        </DarkTypography>
      </DarkTypography>
      <Sheet sx={hrSheetSx}>
        <Table hoverRow sx={hrTableSx}>
          <thead>
            <tr>
              <th>Nom</th>
              <th>Prix HT</th>
              <th>TVA</th>
              <th>Prix TTC</th>
              <th>Formations</th>
              <th>Statut</th>
              {canEdit && <th style={{ width: 100 }}>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {items.map((p) => (
              <tr key={p.ID}>
                <td>{p.Name}</td>
                <td>{formatPrice(p.UnitPrice)}</td>
                <td>{p.TaxRate} %</td>
                <td>{formatPrice(htToTtc(p.UnitPrice, p.TaxRate))}</td>
                <td>
                  {(p.TrainingTemplateIDs ?? []).length > 0
                    ? p.TrainingTemplateIDs.map((id) => (
                        <Chip key={id} size="sm" variant="soft" sx={{ mr: 0.5, mb: 0.25 }}>
                          {qualifMap.get(id) ?? `#${id}`}
                        </Chip>
                      ))
                    : "—"}
                </td>
                <td>
                  <Chip size="sm" color={p.IsActive ? "success" : "neutral"} variant="soft">
                    {p.IsActive ? "Actif" : "Inactif"}
                  </Chip>
                </td>
                {canEdit && (
                  <td>
                    <IconButtonCTA aria-label="Modifier" size="sm" onClick={() => onEdit(p)}>
                      <SEdit />
                    </IconButtonCTA>
                    <IconButtonCTA
                      aria-label="Supprimer"
                      size="sm"
                      ctaVariant="danger"
                      onClick={() => onDelete(p)}
                    >
                      <SDelete />
                    </IconButtonCTA>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
      </Sheet>
    </DarkCard>
  );
}
